module.exports = __webpack_public_path__ + "img/studio.127e9590.jpg";